module.exports = __webpack_public_path__ + "img/no-video.ab3c2a8e.svg";